<div class="content">
  <form [formGroup]="form">
    <automata-automation-replacement-chips
      [label]="'AUTOMATIONS.EDITOR.TASKS.CREATE_CALL_ACTIVITY.CALL_OUTCOME' | translate"
      [dataService]="callOutcomeService"
      [formControl]="form.controls[callOutcomeFieldId]"
      [isRequired]="false"
      [multiple]="false"
      [supportDataPassing]="true"
    >
    </automata-automation-replacement-chips>
  </form>
</div>
